import gql from "graphql-tag";

export const QUERY_GET_CREATOR_APPLICATIONS = gql`
  query CreatorApplications {
    creatorApplications {
      id
      firstname
      pseudo
      followers
      email
      invitationCode
      inviterUsername
      tipshoutUsername
      status
      createdAt
    }
  }
`;

export const MUTATION_APPROVE_APPLICATION = gql`
  mutation ApproveCreatorApplication($input: ApproveApplicationInput!) {
    approveCreatorApplication(input: $input) {
      id
      status
      tipshoutUsername
    }
  }
`;

export const MUTATION_REJECT_APPLICATION = gql`
  mutation RejectCreatorApplication($id: String!) {
    rejectCreatorApplication(id: $id) {
      id
      status
    }
  }
`;
